import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "mr-1",
  style: {"font-size":"x-small","width":"100%","text-align":"center","text-overflow":"ellipsis"}
}
const _hoisted_3 = {
  class: "mr-1",
  style: {"font-size":"x-small","width":"100%","text-align":"center","text-overflow":"ellipsis"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "mr-1",
  style: {"font-size":"x-small","width":"100%","text-align":"center","text-overflow":"ellipsis"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "d-inline-block pr-1",
  style: {"cursor":"move"}
}
const _hoisted_8 = { class: "d-inline-block pl-1" }
const _hoisted_9 = { class: "d-inline-block px-1" }
const _hoisted_10 = { class: "d-inline-block px-1" }
const _hoisted_11 = {
  class: "d-inline-block pr-1",
  style: {"cursor":"move"}
}
const _hoisted_12 = { class: "d-inline-block pl-1" }
const _hoisted_13 = { class: "d-inline-block px-1" }
const _hoisted_14 = { class: "d-inline-block px-1" }
const _hoisted_15 = { class: "d-flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_VSelectFilled = _resolveComponent("VSelectFilled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_CustomNumberField = _resolveComponent("CustomNumberField")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_AdvancedBoxEditor = _resolveComponent("AdvancedBoxEditor")!
  const _component_VTextFieldFilled = _resolveComponent("VTextFieldFilled")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_LegalForm = _resolveComponent("LegalForm")!
  const _component_InvoiceAdvanceSetting = _resolveComponent("InvoiceAdvanceSetting")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTabInvoiceTheme,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabInvoiceTheme) = $event)),
        "fixed-tabs": "",
        grow: "",
        style: {"background-color":"transparent !important","border-radius":"12px"},
        class: "mb-1 w-100"
      }, {
        default: _withCtx(() => [
          (_ctx.showInformationsTab)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 0,
                rounded: "0",
                ripple: "",
                value: "showInformationsTab"
              }, {
                default: _withCtx(() => _cache[147] || (_cache[147] = [
                  _createTextVNode("Mes Informations")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showInvoiceThemeTab)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 1,
                rounded: "0",
                ripple: "",
                value: "showInvoiceThemeTab",
                "data-cy": "InvoiceThemeMenu-theme"
              }, {
                default: _withCtx(() => _cache[148] || (_cache[148] = [
                  _createTextVNode("Thèmes")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_tab, {
            "data-cy": "invoice-settings",
            rounded: "0",
            riple: "",
            value: "showAdvanceSettingsTab"
          }, {
            default: _withCtx(() => _cache[149] || (_cache[149] = [
              _createTextVNode("Paramètres avancés")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.activeTabInvoiceTheme,
        "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ((_ctx.activeTabInvoiceTheme) = $event)),
        class: "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, {
            key: "showInvoiceThemeTab",
            value: "showInvoiceThemeTab",
            class: "fill-height pt-1 ml-2 mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "d-flex flex-row",
                style: {"position":"sticky","top":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex align-center justify-end px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VBtn, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitSaveTheme())),
                        size: "small",
                        "data-cy": "InvoiceThemeMenu-save"
                      }, {
                        default: _withCtx(() => _cache[150] || (_cache[150] = [
                          _createTextVNode(" Enregistrer ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "d-flex pl-2 mb-2 justify-start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_checkbox, _mergeProps({
                            modelValue: _ctx.invoiceThemeSettings.useAdvancedStyling,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceThemeSettings.useAdvancedStyling) = $event)),
                            color: "primary",
                            label: "Utiliser les options avancées de mise en page",
                            density: "compact",
                            "hide-details": "auto"
                          }, props), null, 16, ["modelValue"])
                        ]),
                        default: _withCtx(() => [
                          _cache[151] || (_cache[151] = _createElementVNode("span", null, "La mise en page avancée vous permet de définir avec précision la taille du contenu et des boîtes.", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VSelectFilled, {
                        items: _ctx.previewDocumentTypes,
                        label: "Type de document du preview",
                        density: "compact",
                        "hide-details": "",
                        "model-value": _ctx.selectedPreviewDocumentType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPreviewDocumentType($event))),
                        "data-cy": "InvoiceThemeMenu-typeDeDocumentPreview"
                      }, null, 8, ["items", "model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panels, { class: "mb-3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editing(null)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[152] || (_cache[152] = _createElementVNode("b", null, "Thèmes et arrière-plans", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex mb-2"
                                      }, {
                                        default: _withCtx(() => _cache[153] || (_cache[153] = [
                                          _createElementVNode("label", { class: "theme--light" }, "Choisir un thème", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex mb-2 hide-scrollbar",
                                        style: {"overflow-y":"auto"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            style: {"cursor":"pointer"},
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTheme({ name: 'Personal' })))
                                          }, [
                                            _createVNode(_component_v_card, {
                                              flat: "",
                                              variant: "outlined",
                                              class: "mx-1",
                                              rounded: "sm",
                                              color: 
                                                        _ctx.isThemeSelected({ name: 'Personal' })
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    ,
                                              style: _normalizeStyle({
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: _ctx.isThemeSelected({
                                                            name: 'Personal',
                                                        })
                                                            ? '2px'
                                                            : '',
                                                    })
                                            }, null, 8, ["color", "style"]),
                                            _cache[154] || (_cache[154] = _createElementVNode("div", {
                                              class: "mr-1",
                                              style: {"font-size":"small","width":"100%","text-align":"center","text-overflow":"ellipsis"}
                                            }, " Votre thème personnalisé ", -1))
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableThemes, (theme) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: theme.name,
                                              style: {"cursor":"pointer"},
                                              onClick: ($event: any) => (_ctx.selectTheme(theme))
                                            }, [
                                              (theme.name === 'Par défaut')
                                                ? (_openBlock(), _createBlock(_component_v_card, {
                                                    key: 0,
                                                    flat: "",
                                                    variant: "outlined",
                                                    rounded: "sm",
                                                    class: "mx-1",
                                                    color: 
                                                        _ctx.isThemeSelected(theme)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    ,
                                                    style: _normalizeStyle({
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: _ctx.isThemeSelected(theme)
                                                            ? '2px'
                                                            : '',
                                                    })
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_img, {
                                                        src: theme.thumbnailUri,
                                                        alt: theme.name,
                                                        style: {"max-height":"149px"}
                                                      }, null, 8, ["src", "alt"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color", "style"]))
                                                : (_openBlock(), _createBlock(_component_v_card, {
                                                    key: 1,
                                                    flat: "",
                                                    variant: "outlined",
                                                    rounded: "sm",
                                                    class: "mx-1",
                                                    color: 
                                                        _ctx.isThemeSelected(theme)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    ,
                                                    style: _normalizeStyle({
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: _ctx.isThemeSelected(theme)
                                                            ? '2px'
                                                            : '',
                                                    })
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_img, {
                                                        src: theme.thumbnailUri,
                                                        alt: theme.name,
                                                        style: {"max-height":"149px"}
                                                      }, null, 8, ["src", "alt"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color", "style"])),
                                              _createElementVNode("div", _hoisted_2, _toDisplayString(theme.name), 1)
                                            ], 8, _hoisted_1))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ) = $event)),
                                            color: "primary",
                                            label: "Choisir un fond par défaut ou ajouter un fond personnalisé",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex mb-2 hide-scrollbar",
                                        style: {"overflow-y":"auto"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_v_card, {
                                              flat: "",
                                              variant: "outlined",
                                              rounded: "sm",
                                              class: "mx-1 flex align-center justify-center",
                                              color: 
                                                        _ctx.isPersonalizedBackgroundSelected
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    ,
                                              style: _normalizeStyle({
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth:
                                                            _ctx.isPersonalizedBackgroundSelected
                                                                ? '2px'
                                                                : '',
                                                    })
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.personalizedBgImage)
                                                  ? (_openBlock(), _createBlock(_component_v_img, {
                                                      key: 0,
                                                      src: _ctx.personalizedBgImage,
                                                      alt: "Fond personnalisé",
                                                      style: {"max-height":"149px","cursor":"pointer"},
                                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectPersonalizedBackground()))
                                                    }, null, 8, ["src"]))
                                                  : (_openBlock(), _createBlock(_component_v_row, {
                                                      key: 1,
                                                      class: "no-gutters d-flex align-center justify-center",
                                                      style: {"height":"149px"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_btn_icon, {
                                                          onClick: _ctx.openInvoiceBgUploadDialog,
                                                          disabled: 
                                                                !_ctx.invoiceThemeSettings.page
                                                                    .useBackgroundImage
                                                            ,
                                                          icon: "$oss-upload"
                                                        }, null, 8, ["onClick", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }))
                                              ]),
                                              _: 1
                                            }, 8, ["color", "style"]),
                                            _createElementVNode("div", _hoisted_3, [
                                              _cache[155] || (_cache[155] = _createElementVNode("span", null, "Personnalisé", -1)),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-upload",
                                                onClick: _ctx.openInvoiceBgUploadDialog,
                                                disabled: 
                                                            !_ctx.invoiceThemeSettings.page
                                                                .useBackgroundImage
                                                        ,
                                                style: {"font-size":"x-small","padding":"0"}
                                              }, null, 8, ["onClick", "disabled"])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultBackgroundsDataList, (img) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: img.name,
                                              style: {"cursor":"pointer"},
                                              onClick: ($event: any) => (_ctx.selectDefaultBackground(img.fileKey))
                                            }, [
                                              _createVNode(_component_v_card, {
                                                flat: "",
                                                variant: "outlined",
                                                rounded: "sm",
                                                class: "mx-1",
                                                color: 
                                                        _ctx.isDefaultBackgroundSelected(img.fileKey)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    ,
                                                style: _normalizeStyle({
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: _ctx.isDefaultBackgroundSelected(
                                                            img.fileKey,
                                                        )
                                                            ? '2px'
                                                            : '',
                                                    })
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_img, {
                                                    src: img.signedUrl,
                                                    alt: img.name,
                                                    style: {"max-height":"149px"}
                                                  }, null, 8, ["src", "alt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["color", "style"]),
                                              _createElementVNode("div", _hoisted_5, _toDisplayString(img.name), 1)
                                            ], 8, _hoisted_4))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.backgroundSizeItems,
                                            label: "Taille de l'arrière-plan",
                                            "hide-details": "",
                                            disabled: 
                                                    !_ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ,
                                            modelValue: _ctx.invoiceThemeSettings.page.backgroundSize,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.invoiceThemeSettings.page.backgroundSize) = $event)),
                                            density: "compact"
                                          }, null, 8, ["items", "disabled", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.backgroundPositionItems,
                                            label: "Position de l'arrière-plan",
                                            "hide-details": "",
                                            disabled: 
                                                    !_ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ,
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.backgroundPosition
                                                ,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.backgroundPosition
                                                ) = $event)),
                                            density: "compact"
                                          }, null, 8, ["items", "disabled", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.backgroundRepeatItems,
                                            label: "Répétition de l'arrière-plan",
                                            "hide-details": "",
                                            disabled: 
                                                    !_ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ,
                                            modelValue: _ctx.invoiceThemeSettings.page.backgroundRepeat,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.invoiceThemeSettings.page.backgroundRepeat) = $event)),
                                            density: "compact"
                                          }, null, 8, ["items", "disabled", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CustomNumberField, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.backgroundOpacity
                                                ,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.backgroundOpacity
                                                ) = $event)),
                                            label: "Opacité",
                                            step: 1,
                                            min: 0,
                                            max: 100,
                                            disabled: 
                                                    !_ctx.invoiceThemeSettings.page.useBackgroundImage
                                                ,
                                            "hide-details": "",
                                            "data-cy": "InvoiceThmeMenu-opacite"
                                          }, {
                                            "pre-append": _withCtx(() => _cache[156] || (_cache[156] = [
                                              _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, " % ", -1)
                                            ])),
                                            _: 1
                                          }, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.editing(null))),
                            "data-cy": "InvoiceThemeMenu-general"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[157] || (_cache[157] = _createElementVNode("b", null, "Général", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex flex-column pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CustomNumberField, {
                                            modelValue: _ctx.horizontalMargin,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.horizontalMargin) = $event)),
                                            label: "Marges horizontales",
                                            class: "mt-3",
                                            step: 0.1,
                                            min: 0,
                                            "hide-details": "",
                                            "data-cy": "InvoiceThemeMenu-margesHorizontales"
                                          }, {
                                            "pre-append": _withCtx(() => _cache[158] || (_cache[158] = [
                                              _createElementVNode("span", null, "mm", -1)
                                            ])),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex flex-column pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CustomNumberField, {
                                            modelValue: _ctx.verticalMargin,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.verticalMargin) = $event)),
                                            label: "Marges verticales",
                                            class: "mt-3",
                                            step: 0.1,
                                            min: 0,
                                            "hide-details": "",
                                            "data-cy": "InvoiceThemeMenu-margesVerticales"
                                          }, {
                                            "pre-append": _withCtx(() => _cache[159] || (_cache[159] = [
                                              _createElementVNode("span", null, "mm", -1)
                                            ])),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.fonts,
                                            label: "Police",
                                            density: "compact",
                                            "hide-details": "",
                                            "model-value": _ctx.selectedFontFamily,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = 
                                                    (val) => _ctx.handleFontSelectChange(val)
                                                ),
                                            "data-cy": "InvoiceThemeMenu-police"
                                          }, {
                                            item: _withCtx(({ item, props }) => [
                                              _createVNode(_component_v_list_item, _mergeProps(props, {
                                                title: null,
                                                style: {"width":"100%"}
                                              }), {
                                                default: _withCtx(() => [
                                                  (item.raw !== 'Par défaut')
                                                    ? (_openBlock(), _createBlock(_component_v_list_item_title, _mergeProps({ key: 0 }, props, {
                                                        onMouseover: ($event: any) => (_ctx.onFontMouseOver(item.raw)),
                                                        onMouseleave: ($event: any) => (_ctx.onFontMouseLeave(item.raw)),
                                                        style: {
                                                                fontFamily: item.raw,
                                                                width: '100%',
                                                                cursor: 'pointer',
                                                            }
                                                      }), {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.raw), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["onMouseover", "onMouseleave", "style"]))
                                                    : (_openBlock(), _createBlock(_component_v_list_item_title, { key: 1 }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.raw), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            selection: _withCtx(({ item, index }) => [
                                              (item.raw !== 'Par défaut')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    style: _normalizeStyle({ fontFamily: item.raw })
                                                  }, _toDisplayString(item.raw), 5))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.raw), 1))
                                            ]),
                                            _: 1
                                          }, 8, ["items", "model-value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CustomNumberField, {
                                            modelValue: _ctx.selectedFontSize,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedFontSize) = $event)),
                                            label: "Taille de police",
                                            step: 1,
                                            min: 1,
                                            max: _ctx.maxFontSize,
                                            "hide-details": "",
                                            "data-cy": "InvoiceThemeMenu-taillePolice"
                                          }, null, 8, ["modelValue", "max"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.invoiceBgUploadDialog)
                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                    key: 0,
                                    modelValue: _ctx.invoiceBgUploadDialog,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.invoiceBgUploadDialog) = $event)),
                                    title: "Importer un arrière plan",
                                    actions: _ctx.actions,
                                    "max-width": "900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UploadDocuments, {
                                        key: "background",
                                        companyId: _ctx.companyId,
                                        documentType: 'BOOKLET_TEMPLATE',
                                        multiple: false,
                                        freeTag: false,
                                        actions: _ctx.actions,
                                        showActionsBtn: true,
                                        inExtensions: ['png', 'jpg', 'webp', 'jpeg'],
                                        onFile: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateInvoiceBackground($event))),
                                        onFileUploaded: _cache[17] || (_cache[17] = ($event: any) => (_ctx.invoiceBgUploadDialog = false))
                                      }, null, 8, ["companyId", "actions"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "actions"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.editing('invoiceHeader-block'))),
                            "data-cy": "InvoiceThemeMenu-enTeteDeLaPage"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[160] || (_cache[160] = _createElementVNode("b", null, "En-tête de la page", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto",
                                            "data-cy": "InvoiceThemeMenu-cacherLeBloc"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.style.displayHeaderDivider
                                                ,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.style.displayHeaderDivider
                                                ) = $event)),
                                            label: "Afficher le trait de séparation",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-traitSeparation"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.showLogo,
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showLogo) = $event)),
                                            label: "Logo",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-logo"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "8",
                                        class: "d-flex flex-column pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            modelValue: _ctx.logoSizeMultiplier,
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.logoSizeMultiplier) = $event)),
                                            "show-ticks": false,
                                            color: "primary",
                                            density: "compact",
                                            max: "500",
                                            min: "0",
                                            step: "10",
                                            label: "Taille du logo",
                                            "hide-details": "",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.showInvoiceType
                                                ,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.showInvoiceType
                                                ) = $event)),
                                            color: "primary",
                                            label: "Afficher le type de facture",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.useInvoiceNumber
                                                ,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.useInvoiceNumber
                                                ) = $event)),
                                            label: "Utiliser le numéro de la facture à la place",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-numeroFacture"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.logoOnRightSide,
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.logoOnRightSide) = $event)),
                                            label: "Logo à droite",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-logoDroite"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.headerContentBox.style,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.invoiceThemeSettings.headerContentBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoiceHeader-block",
                                        title: "Options avancéees d'édition de l'entête",
                                        onEditing: _ctx.editing,
                                        unusedOptions: _ctx.hiddenUnusedOption,
                                        disabled: 
                                            _ctx.invoiceThemeSettings.headerContentBox.style.hidden
                                        
                                      }, null, 8, ["modelValue", "onEditing", "unusedOptions", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 1,
                                        modelValue: 
                                            _ctx.invoiceThemeSettings.headerContentBox.iconBox.style
                                        ,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((
                                            _ctx.invoiceThemeSettings.headerContentBox.iconBox.style
                                        ) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoiceHeaderLogo-block",
                                        title: "Options avancéees de format du logo",
                                        onEditing: _ctx.editing,
                                        disabled: 
                                            _ctx.invoiceThemeSettings.headerContentBox.style.hidden
                                        ,
                                        disabledHidden: 
                                            _ctx.invoiceThemeSettings.headerContentBox.style.hidden
                                        
                                      }, null, 8, ["modelValue", "onEditing", "disabled", "disabledHidden"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 2,
                                        modelValue: 
                                            _ctx.invoiceThemeSettings.headerContentBox.invoiceTypeBox
                                                .style
                                        ,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((
                                            _ctx.invoiceThemeSettings.headerContentBox.invoiceTypeBox
                                                .style
                                        ) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoiceHeaderType-block",
                                        title: "Options avancéees de format du type de document",
                                        onEditing: _ctx.editing,
                                        disabled: 
                                            _ctx.invoiceThemeSettings.headerContentBox.style.hidden
                                        ,
                                        disabledHidden: 
                                            _ctx.invoiceThemeSettings.headerContentBox.style.hidden
                                        
                                      }, null, 8, ["modelValue", "onEditing", "disabled", "disabledHidden"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.editing('emitter-block'))),
                            "data-cy": "InvoiceThemeMenu-emmetteur"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[161] || (_cache[161] = _createElementVNode("b", null, "Emetteur", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.style.hidden,
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.style.hidden) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto",
                                            "data-cy": "InvoiceThemeMenu-emetteurCacherBloc"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "6" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.logo,
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.logo) = $event)),
                                            color: "primary",
                                            label: "Logo",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.invoiceThemeSettings.emitter.logo)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(_component_v_col, {
                                              cols: "8",
                                              class: "d-flex flex-column pl-2 mt-2 mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_slider, {
                                                  modelValue: _ctx.logoSizeMultiplier,
                                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.logoSizeMultiplier) = $event)),
                                                  "show-ticks": false,
                                                  max: "500",
                                                  min: "0",
                                                  step: "10",
                                                  label: "Taille du logo",
                                                  "hide-details": "",
                                                  disabled: !_ctx.invoiceThemeSettings.emitter.logo
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "4" })
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.name,
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.name) = $event)),
                                            color: "primary",
                                            label: "Nom émetteur",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.address,
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.address) = $event)),
                                            color: "primary",
                                            label: "Adresse émetteur",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.siret,
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.siret) = $event)),
                                            color: "primary",
                                            label: "Siret émetteur",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.tva,
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.tva) = $event)),
                                            color: "primary",
                                            label: "TVA",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.emitter.style.border,
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.style.border) = $event)),
                                            color: "primary",
                                            label: "Bordures",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.borderColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.borderColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Bordures",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    !_ctx.invoiceThemeSettings.emitter
                                                                        .style.border ||
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'emitter.style.borderColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.emitterBorderColor,
                                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.emitterBorderColor) = $event)),
                                                "show-swatches": "",
                                                "hide-mode-switch": "",
                                                mode: "hexa",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.emitter.style.hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Fond",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    !_ctx.invoiceThemeSettings.emitter
                                                                        .style.border ||
                                                                    _ctx.invoiceThemeSettings.emitter
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'emitter.style.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.emitterBgColor,
                                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.emitterBgColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.emitter.style.hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "pl-2 my-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "6" }, {
                                        default: _withCtx(() => [
                                          _cache[162] || (_cache[162] = _createTextVNode(" Position du texte")),
                                          _cache[163] || (_cache[163] = _createElementVNode("br", null, null, -1)),
                                          _createVNode(_component_v_btn_toggle, {
                                            mandatory: "force",
                                            divided: "",
                                            variant: "outlined",
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.emitter.style.textPosition
                                                ,
                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.emitter.style.textPosition
                                                ) = $event)),
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                ,
                                            density: "comfortable"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-left",
                                                value: "left",
                                                size: "small",
                                                variant: "outlined"
                                              }),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-center",
                                                value: "center",
                                                "data-cy": "InvoiceThemeMenu-center",
                                                size: "small",
                                                variant: "outlined"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.position.emitter
                                                        .sameLevelAsReceiver
                                                ,
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.position.emitter
                                                        .sameLevelAsReceiver
                                                ) = $event)),
                                            color: "primary",
                                            label: "Aligné avec le destinataire",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.emitter.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.emitter.style,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.invoiceThemeSettings.emitter.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "emitter-block",
                                        onEditing: _ctx.editing,
                                        disabled: _ctx.invoiceThemeSettings.emitter.style.hidden,
                                        unusedOptions: [
                                            'hidden',
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                        ]
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.editing('receiver-block'))),
                            "data-cy": "InvoiceThemeMenu-destinataire"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[164] || (_cache[164] = _createElementVNode("b", null, "Destinataire", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.style.hidden,
                                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.style.hidden) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.name,
                                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.name) = $event)),
                                            color: "primary",
                                            label: "Nom destinataire",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.receiver.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-nomDestinataire"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.address,
                                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.address) = $event)),
                                            color: "primary",
                                            label: "Adresse destinataire",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.receiver.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-adresseDestinataire"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.siret,
                                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.siret) = $event)),
                                            color: "primary",
                                            label: "Siret destinataire",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.receiver.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-siretDestinataire"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.tva,
                                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.tva) = $event)),
                                            color: "primary",
                                            label: "TVA",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.receiver.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-TVA"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.receiver.style.border,
                                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.style.border) = $event)),
                                            color: "primary",
                                            label: "Bordures",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.receiver.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.borderColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.borderColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Bordures",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    !_ctx.invoiceThemeSettings.receiver
                                                                        .style.border ||
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'receiver.style.borderColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.receiverBorderColor,
                                                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.receiverBorderColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.receiver.style.hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Fond",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    !_ctx.invoiceThemeSettings.receiver
                                                                        .style.border ||
                                                                    _ctx.invoiceThemeSettings.receiver
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'receiver.style.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.receiverBgColor,
                                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.receiverBgColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.receiver.style.hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex pl-2 my-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "6" }, {
                                        default: _withCtx(() => [
                                          _cache[165] || (_cache[165] = _createTextVNode(" Position du texte")),
                                          _cache[166] || (_cache[166] = _createElementVNode("br", null, null, -1)),
                                          _createVNode(_component_v_btn_toggle, {
                                            mandatory: "force",
                                            divided: "",
                                            variant: "outlined",
                                            density: "comfortable",
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.receiver.style.textPosition
                                                ,
                                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.receiver.style.textPosition
                                                ) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-left",
                                                value: "left",
                                                size: "small",
                                                variant: "outlined"
                                              }),
                                              _createVNode(_component_v_btn_icon, {
                                                "data-cy": "InvoiceThemeMenu-destinataireCenter",
                                                value: "center",
                                                icon: "$fa-align-center",
                                                size: "small",
                                                variant: "outlined"
                                              }),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-right",
                                                value: "right",
                                                size: "small",
                                                variant: "outlined"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.receiver.style,
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.invoiceThemeSettings.receiver.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "receiver-block",
                                        onEditing: _ctx.editing,
                                        unusedOptions: [
                                            'hidden',
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                        ],
                                        disabled: _ctx.invoiceThemeSettings.receiver.style.hidden
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.editing('invoiceTitle-block'))),
                            "data-cy": "InvoiceThemeMenu-titreInfosFacture"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[167] || (_cache[167] = _createElementVNode("b", null, "Titre et infos de la facture", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.titleBox.style.hidden,
                                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.invoiceThemeSettings.titleBox.style.hidden) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.titleBox.style,
                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.invoiceThemeSettings.titleBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoiceTitle-block",
                                        title: "Options avancéees d'édition",
                                        onEditing: _ctx.editing,
                                        divider: false,
                                        unusedOptions: ['hidden'],
                                        disabled: _ctx.invoiceThemeSettings.titleBox.style.hidden
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.editing('mainTable-block'))),
                            "data-cy": "InvoiceThemeMenu-tableauCentral"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[168] || (_cache[168] = _createElementVNode("b", null, "Tableau central", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                ,
                                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.tables
                                                                        .header.backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.tables
                                                                        .header.backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "En-tête",
                                                        density: "compact",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                ,
                                                        "data-cy": "InvoiceThemeMenu-enTeteColor"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'tables.header.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.tableHeaderBgColor,
                                                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.tableHeaderBgColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    ,
                                                "data-cy": "InvoiceThemeMenu-color"
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.tables.rows
                                                                        .backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.tables.rows
                                                                        .backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes",
                                                        density: "compact",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                ,
                                                        "data-cy": "InvoiceThemeMenu-lignes"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'tables.rows.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.tableRowBgColor,
                                                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.tableRowBgColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches
                                              }, null, 8, ["modelValue", "swatches"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.invoiceThemeSettings.tables.rows.border,
                                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.invoiceThemeSettings.tables.rows.border) = $event)),
                                            color: "primary",
                                            label: "Bordures",
                                            density: "compact",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                modelValue: 
                                                            _ctx.invoiceThemeSettings.tables.rows
                                                                .borderColor
                                                        ,
                                                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((
                                                            _ctx.invoiceThemeSettings.tables.rows
                                                                .borderColor
                                                        ) = $event))
                                              }, props, {
                                                label: "Bordures",
                                                readonly: "",
                                                "hide-details": "",
                                                disabled: 
                                                            _ctx.invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        ,
                                                density: "compact"
                                              }), {
                                                "prepend-inner": _withCtx(() => [
                                                  _createElementVNode("div", {
                                                    class: "d-flex align-self-center",
                                                    style: _normalizeStyle(
                                                                    _ctx.colorIconStyle(
                                                                        'tables.rows.borderColor',
                                                                    )
                                                                )
                                                  }, null, 4)
                                                ]),
                                                _: 2
                                              }, 1040, ["modelValue", "disabled"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: _ctx.tableRowBorderColor,
                                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.tableRowBorderColor) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pt-2 pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.tableRowsTypes,
                                            "item-title": "text",
                                            label: "Mode de ligne du tableau",
                                            density: "compact",
                                            "hide-details": "",
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows.mode
                                                ,
                                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows.mode
                                                ) = $event)),
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-modeDeLigneDuTableau"
                                          }, null, 8, ["items", "modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.rows
                                                                        .secondaryBackgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.rows
                                                                        .secondaryBackgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes (secondaire)",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.rows.mode !==
                                                                        'alternating' ||
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'mainTableBox.rows.secondaryBackgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.rows
                                                            .secondaryBackgroundColor
                                                    ,
                                                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.mainTableBox.rows
                                                            .secondaryBackgroundColor
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "py-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _cache[170] || (_cache[170] = _createElementVNode("span", { class: "text-muted" }, "Colonnes", -1)),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_draggable, {
                                                    list: _ctx.tableColumns,
                                                    onChange: _ctx.onDraggableMove,
                                                    "ghost-class": "ghost",
                                                    disabled: 
                                                            _ctx.invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        ,
                                                    itemKey: "",
                                                    class: "v-row v-row--no-gutters"
                                                  }, {
                                                    item: _withCtx(({ element: column }) => [
                                                      (_openBlock(), _createBlock(_component_v_col, {
                                                        key: column.value,
                                                        cols: "12",
                                                        class: "py-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "d-flex align-center justify-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("div", _hoisted_7, [
                                                                _createVNode(_component_v_icon, {
                                                                  icon: "$fa-grip-vertical",
                                                                  size: "x-small",
                                                                  color: "secondary"
                                                                })
                                                              ]),
                                                              _createElementVNode("div", _hoisted_8, [
                                                                _createVNode(_component_v_checkbox, {
                                                                  modelValue: column.checked,
                                                                  "onUpdate:modelValue": [($event: any) => ((column.checked) = $event), 
                                                                                _ctx.updateTableHeaderInTheme
                                                                            ],
                                                                  color: "primary",
                                                                  class: "pa-0",
                                                                  density: "compact",
                                                                  "hide-details": "auto",
                                                                  disabled: 
                                                                                !column.optional ||
                                                                                _ctx.invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden
                                                                            ,
                                                                  "data-cy": 
                                                                                'InvoiceThemeMenu-ajouterSupprimerLigne-' +
                                                                                column.value
                                                                            
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "data-cy"])
                                                              ]),
                                                              _createVNode(_component_v_col, { class: "px-2" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_VTextFieldFilled, {
                                                                    modelValue: column.text,
                                                                    "onUpdate:modelValue": [($event: any) => ((column.text) = $event), 
                                                                                _ctx.updateTableHeaderInTheme
                                                                            ],
                                                                    label: column.column,
                                                                    "hide-details": "",
                                                                    disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            ,
                                                                    density: "compact"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createElementVNode("div", _hoisted_9, [
                                                                _createVNode(_component_v_checkbox, {
                                                                  modelValue: 
                                                                                column.boldText
                                                                            ,
                                                                  "onUpdate:modelValue": [($event: any) => ((
                                                                                column.boldText
                                                                            ) = $event), 
                                                                                _ctx.updateTableHeaderInTheme
                                                                            ],
                                                                  label: "Gras",
                                                                  density: "compact",
                                                                  "hide-details": "",
                                                                  color: "primary",
                                                                  disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            ,
                                                                  "data-cy": "InvoiceThemeMenu-gras"
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_10, [
                                                                _createVNode(_component_v_btn_toggle, {
                                                                  mandatory: "force",
                                                                  modelValue: column.align,
                                                                  "onUpdate:modelValue": [($event: any) => ((column.align) = $event), 
                                                                                _ctx.updateTableHeaderInTheme
                                                                            ],
                                                                  divided: "",
                                                                  variant: "outlined"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-left",
                                                                      value: "left",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    }),
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-center",
                                                                      value: "center",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    }),
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-right",
                                                                      value: "right",
                                                                      "data-cy": "InvoiceThemeMenu-right",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                              ]),
                                                              _createVNode(_component_v_col, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_CustomNumberField, {
                                                                    modelValue: column.width,
                                                                    "onUpdate:modelValue": ($event: any) => ((column.width) = $event),
                                                                    label: "Largeur",
                                                                    step: 1,
                                                                    min: 1,
                                                                    max: 
                                                                                _ctx.mainTableRemainingCellWidthPercent
                                                                            ,
                                                                    placeholder: "Auto",
                                                                    class: "w-100",
                                                                    onChange: _cache[74] || (_cache[74] = 
                                                                                (e) => {
                                                                                    _ctx.mainTableCellInEditionWidth =
                                                                                        e;
                                                                                    _ctx.updateTableHeaderInTheme();
                                                                                }
                                                                            ),
                                                                    "hide-details": "",
                                                                    disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            
                                                                  }, {
                                                                    "pre-append": _withCtx(() => _cache[169] || (_cache[169] = [
                                                                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, " % ", -1)
                                                                    ])),
                                                                    _: 2
                                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "max", "disabled"])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["list", "onChange", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                class: "d-flex pa-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_checkbox, {
                                                    modelValue: 
                                                            _ctx.invoiceThemeSettings.mainTableBox.rows
                                                                .hideProductionDescription
                                                        ,
                                                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((
                                                            _ctx.invoiceThemeSettings.mainTableBox.rows
                                                                .hideProductionDescription
                                                        ) = $event)),
                                                    label: "Cacher la description du produit",
                                                    color: "primary",
                                                    class: "pa-0",
                                                    density: "compact",
                                                    "hide-details": "auto",
                                                    disabled: 
                                                            _ctx.invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        ,
                                                    "data-cy": "InvoiceThemeMenu-cacherLaDescriptionDuProduit"
                                                  }, null, 8, ["modelValue", "disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "py-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => _cache[171] || (_cache[171] = [
                                          _createElementVNode("span", { class: "text-muted" }, "Lignes", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .showDiscountedAmount
                                                ,
                                            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .showDiscountedAmount
                                                ) = $event)),
                                            label: "Afficher le montant après réduction",
                                            color: "primary",
                                            class: "pa-0",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-montantApresReduction"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .crossNetAmount
                                                ,
                                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .crossNetAmount
                                                ) = $event)),
                                            color: "primary",
                                            label: "Barrer le montant HT",
                                            class: "pa-0",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style
                                                        .hidden ||
                                                    !_ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .showDiscountedAmount
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .showPercentDiscountAmount
                                                ,
                                            "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox.rows
                                                        .showPercentDiscountAmount
                                                ) = $event)),
                                            color: "primary",
                                            label: "Afficher le montant de la réduction",
                                            class: "pa-0",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "py-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "mb-2"
                                      }, {
                                        default: _withCtx(() => _cache[172] || (_cache[172] = [
                                          _createElementVNode("span", { class: "text-muted" }, "Couleurs du texte dans le tableau", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.mainTableBox
                                                        .automaticColors
                                                ,
                                            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.mainTableBox
                                                        .automaticColors
                                                ) = $event)),
                                            color: "primary",
                                            label: "Automatique",
                                            class: "pa-0",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.mainTableBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.header.color
                                                                ,
                                                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.header.color
                                                                ) = $event))
                                                      }, props, {
                                                        label: "En-tête",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox
                                                                        .automaticColors ||
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'mainTableBox.header.color',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.header
                                                            .color
                                                    ,
                                                "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.mainTableBox.header
                                                            .color
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.mainTableBox
                                                            .automaticColors ||
                                                        _ctx.invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.rows.color
                                                                ,
                                                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.rows.color
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox
                                                                        .automaticColors ||
                                                                    _ctx.invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'mainTableBox.rows.color',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.mainTableBox.rows.color
                                                    ,
                                                "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.mainTableBox.rows.color
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.mainTableBox
                                                            .automaticColors ||
                                                        _ctx.invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.mainTableBox.style,
                                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.invoiceThemeSettings.mainTableBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "mainTable-block",
                                        unusedOptions: [
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                            'color',
                                            'hidden',
                                        ],
                                        maxValues: { borderRadius: _ctx.mainTableBorderRadiusMax },
                                        disabled: _ctx.invoiceThemeSettings.mainTableBox.style.hidden,
                                        onEditing: _ctx.editing
                                      }, null, 8, ["modelValue", "maxValues", "disabled", "onEditing"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.editing('deposits-block'))),
                            "data-cy": "InvoiceThemeMenu-acomptes"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[173] || (_cache[173] = _createElementVNode("b", null, "Acomptes", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.depositsBox.style.hidden
                                                ,
                                            "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.depositsBox.style.hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.depositsBox.style,
                                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.invoiceThemeSettings.depositsBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "deposits-block",
                                        title: "Options avancéees d'édition",
                                        divider: false,
                                        onEditing: _ctx.editing,
                                        unusedOptions: ['hidden'],
                                        disabled: _ctx.invoiceThemeSettings.depositsBox.style.hidden
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.editing('totals-block'))),
                            "data-cy": "InvoiceThemeMenu-recapitulatif"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[174] || (_cache[174] = _createElementVNode("b", null, "Récapitulatif", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.totalsBox.style.hidden
                                                ,
                                            "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.totalsBox.style.hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.totalsBox.style,
                                        "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.invoiceThemeSettings.totalsBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "totals-block",
                                        divider: false,
                                        onEditing: _ctx.editing,
                                        unusedOptions: ['hidden'],
                                        disabled: _ctx.invoiceThemeSettings.totalsBox.style.hidden
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[113] || (_cache[113] = ($event: any) => (_ctx.editing('vatTable-block'))),
                            "data-cy": "InvoiceThemeMenu-recapitulatifTVA"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[175] || (_cache[175] = _createElementVNode("b", null, "Récapitulatif de TVA", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "7",
                                        class: "d-flex mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: _ctx.showVATSummary,
                                            "onUpdate:modelValue": [
                                              _cache[92] || (_cache[92] = ($event: any) => ((_ctx.showVATSummary) = $event)),
                                              _cache[93] || (_cache[93] = ($event: any) => (
                                                    _ctx.invoiceThemeSettings.vatTableBox.style.hidden =
                                                        !$event
                                                ))
                                            ],
                                            label: "Afficher un tableau récapitulatif",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            "data-cy": "InvoiceThemeMenu-afficherUnTableauRecapitulatif"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "5",
                                        class: "d-flex pl-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VBtn, {
                                            class: "ml-2",
                                            size: "small",
                                            dark: "",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.style.hidden
                                                ,
                                            onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.copyMainTableSettings())),
                                            "data-cy": "InvoiceThemeMenu-copier"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: "$fa-clone",
                                                size: "small",
                                                class: "mr-2"
                                              }),
                                              _cache[176] || (_cache[176] = _createElementVNode("span", { style: {"font-size":"0.8em"} }, "Copier le tableau central", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"]),
                                          _createVNode(_component_v_snackbar, {
                                            modelValue: _ctx.tableConfCopySnackBar,
                                            "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.tableConfCopySnackBar) = $event)),
                                            color: "success"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_icon, { icon: "$fa-check" })
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[177] || (_cache[177] = _createTextVNode(" Configuration copiée avec succès! "))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .header.backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .header.backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "En-tête",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'vatTableBox.header.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.header
                                                            .backgroundColor
                                                    ,
                                                "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.header
                                                            .backgroundColor
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows.backgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows.backgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'vatTableBox.rows.backgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .backgroundColor
                                                    ,
                                                "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .backgroundColor
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.rows.border
                                                ,
                                            "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.vatTableBox.rows.border
                                                ) = $event)),
                                            color: "primary",
                                            label: "Bordures",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                modelValue: 
                                                            _ctx.invoiceThemeSettings.vatTableBox.rows
                                                                .borderColor
                                                        ,
                                                "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((
                                                            _ctx.invoiceThemeSettings.vatTableBox.rows
                                                                .borderColor
                                                        ) = $event))
                                              }, props, {
                                                label: "Bordures",
                                                readonly: "",
                                                "hide-details": "",
                                                disabled: 
                                                            _ctx.invoiceThemeSettings.vatTableBox.style
                                                                .hidden
                                                        ,
                                                density: "compact"
                                              }), {
                                                "prepend-inner": _withCtx(() => [
                                                  _createElementVNode("div", {
                                                    class: "d-flex align-self-center",
                                                    style: _normalizeStyle(
                                                                    _ctx.colorIconStyle(
                                                                        'vatTableBox.rows.borderColor',
                                                                    )
                                                                )
                                                  }, null, 4)
                                                ]),
                                                _: 2
                                              }, 1040, ["modelValue", "disabled"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .borderColor
                                                    ,
                                                "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .borderColor
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pt-2 pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VSelectFilled, {
                                            items: _ctx.tableRowsTypes,
                                            label: "Mode de ligne du tableau",
                                            "item-title": "text",
                                            "hide-details": "",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.style.hidden
                                                ,
                                            modelValue: _ctx.invoiceThemeSettings.vatTableBox.rows.mode,
                                            "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.invoiceThemeSettings.vatTableBox.rows.mode) = $event)),
                                            density: "compact"
                                          }, null, 8, ["items", "disabled", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows
                                                                        .secondaryBackgroundColor
                                                                ,
                                                        "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows
                                                                        .secondaryBackgroundColor
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes (secondaire)",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows.mode !=
                                                                        'alternating' ||
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'vatTableBox.rows.secondaryBackgroundColor',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .secondaryBackgroundColor
                                                    ,
                                                "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows
                                                            .secondaryBackgroundColor
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _cache[179] || (_cache[179] = _createElementVNode("span", { class: "text-muted" }, "Colonnes", -1)),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_draggable, {
                                                    list: _ctx.vatTableColumns,
                                                    onChange: _ctx.onVATColumnsDraggableMove,
                                                    "ghost-class": "ghost",
                                                    itemKey: "",
                                                    class: "v-row v-row--no-gutters"
                                                  }, {
                                                    item: _withCtx(({ element: column }) => [
                                                      (_openBlock(), _createBlock(_component_v_col, {
                                                        key: column.value,
                                                        cols: "12",
                                                        class: "py-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "d-flex align-center justify-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("div", _hoisted_11, [
                                                                _createVNode(_component_v_icon, {
                                                                  icon: "$fa-grip-vertical",
                                                                  size: "small"
                                                                })
                                                              ]),
                                                              _createElementVNode("div", _hoisted_12, [
                                                                _createVNode(_component_v_checkbox, {
                                                                  modelValue: column.checked,
                                                                  "onUpdate:modelValue": [($event: any) => ((column.checked) = $event), 
                                                                                _ctx.updateVATTableHeaderInTheme
                                                                            ],
                                                                  color: "primary",
                                                                  class: "pa-0",
                                                                  density: "compact",
                                                                  "hide-details": "auto",
                                                                  disabled: 
                                                                                !column.optional ||
                                                                                _ctx.invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden
                                                                            
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                              ]),
                                                              _createVNode(_component_v_col, { class: "px-2" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_VTextFieldFilled, {
                                                                    modelValue: column.text,
                                                                    "onUpdate:modelValue": [($event: any) => ((column.text) = $event), 
                                                                                _ctx.updateVATTableHeaderInTheme
                                                                            ],
                                                                    label: column.column,
                                                                    "hide-details": "",
                                                                    disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            ,
                                                                    density: "compact"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createElementVNode("div", _hoisted_13, [
                                                                _createVNode(_component_v_checkbox, {
                                                                  modelValue: 
                                                                                column.boldText
                                                                            ,
                                                                  "onUpdate:modelValue": [($event: any) => ((
                                                                                column.boldText
                                                                            ) = $event), 
                                                                                _ctx.updateVATTableHeaderInTheme
                                                                            ],
                                                                  color: "primary",
                                                                  label: "Gras",
                                                                  density: "compact",
                                                                  "hide-details": "",
                                                                  disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_14, [
                                                                _createVNode(_component_v_btn_toggle, {
                                                                  mandatory: "force",
                                                                  modelValue: column.align,
                                                                  "onUpdate:modelValue": [($event: any) => ((column.align) = $event), 
                                                                                _ctx.updateVATTableHeaderInTheme
                                                                            ],
                                                                  divided: "",
                                                                  variant: "outlined"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-left",
                                                                      value: "left",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    }),
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-center",
                                                                      value: "center",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    }),
                                                                    _createVNode(_component_v_btn_icon, {
                                                                      icon: "$fa-align-right",
                                                                      value: "right",
                                                                      size: "x-small",
                                                                      variant: "outlined"
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                              ]),
                                                              _createVNode(_component_v_col, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_CustomNumberField, {
                                                                    modelValue: column.width,
                                                                    "onUpdate:modelValue": ($event: any) => ((column.width) = $event),
                                                                    label: "Largeur",
                                                                    step: 1,
                                                                    min: 1,
                                                                    max: 
                                                                                _ctx.vatTableRemainingCellWidthPercent
                                                                            ,
                                                                    placeholder: "Auto",
                                                                    onChange: _cache[106] || (_cache[106] = 
                                                                                (e) => {
                                                                                    _ctx.vatTableCellInEditionWidth =
                                                                                        e;
                                                                                    _ctx.updateVATTableHeaderInTheme();
                                                                                }
                                                                            ),
                                                                    "hide-details": "",
                                                                    disabled: 
                                                                                _ctx.invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            
                                                                  }, {
                                                                    "pre-append": _withCtx(() => _cache[178] || (_cache[178] = [
                                                                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, " % ", -1)
                                                                    ])),
                                                                    _: 2
                                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "max", "disabled"])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["list", "onChange"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "py-3 mt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "mb-2"
                                      }, {
                                        default: _withCtx(() => _cache[180] || (_cache[180] = [
                                          _createElementVNode("span", { class: "text-muted" }, "Couleurs du texte dans le tableau", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.automaticColors
                                                ,
                                            "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.vatTableBox.automaticColors
                                                ) = $event)),
                                            color: "primary",
                                            label: "Automatique",
                                            class: "pa-0",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.vatTableBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .header.color
                                                                ,
                                                        "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .header.color
                                                                ) = $event))
                                                      }, props, {
                                                        label: "En-tête",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .automaticColors ||
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'vatTableBox.header.color',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.header
                                                            .color
                                                    ,
                                                "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.header
                                                            .color
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox
                                                            .automaticColors ||
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "offset-y": "",
                                            "close-on-content-click": false
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                                                        modelValue: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows.color
                                                                ,
                                                        "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .rows.color
                                                                ) = $event))
                                                      }, props, {
                                                        label: "Lignes",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        disabled: 
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .automaticColors ||
                                                                    _ctx.invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                ,
                                                        density: "compact"
                                                      }), {
                                                        "prepend-inner": _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            class: "d-flex align-self-center",
                                                            style: _normalizeStyle(
                                                                            _ctx.colorIconStyle(
                                                                                'vatTableBox.rows.color',
                                                                            )
                                                                        )
                                                          }, null, 4)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_color_picker, {
                                                modelValue: 
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows.color
                                                    ,
                                                "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((
                                                        _ctx.invoiceThemeSettings.vatTableBox.rows.color
                                                    ) = $event)),
                                                "show-swatches": "",
                                                mode: "hexa",
                                                "hide-mode-switch": "",
                                                swatches: _ctx.swatches,
                                                disabled: 
                                                        _ctx.invoiceThemeSettings.vatTableBox
                                                            .automaticColors ||
                                                        _ctx.invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    
                                              }, null, 8, ["modelValue", "swatches", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.vatTableBox.style,
                                        "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.invoiceThemeSettings.vatTableBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "vatTable-block",
                                        unusedOptions: [
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                            'color',
                                            'hidden',
                                        ],
                                        disabled: _ctx.invoiceThemeSettings.vatTableBox.style.hidden,
                                        maxValues: { borderRadius: _ctx.vatTableBorderRadiusMax },
                                        onEditing: _ctx.editing
                                      }, null, 8, ["modelValue", "disabled", "maxValues", "onEditing"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.editing('invoicePaymentDetails-block'))),
                            "data-cy": "InvoiceThemeMenu-detailsPaiement"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[181] || (_cache[181] = _createElementVNode("b", null, "Détails du paiement", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.paymentDetailsBox.style
                                                        .hidden
                                                ,
                                            "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.paymentDetailsBox.style
                                                        .hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.paymentDetailsBox.style,
                                        "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.invoiceThemeSettings.paymentDetailsBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoicePaymentDetails-block",
                                        title: "Options avancéees d'édition",
                                        divider: false,
                                        onEditing: _ctx.editing,
                                        disabled: 
                                            _ctx.invoiceThemeSettings.paymentDetailsBox.style.hidden
                                        ,
                                        unusedOptions: ['hidden']
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.editing('pagination-block'))),
                            "data-cy": "InvoiceThemeMenu-pagination"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[182] || (_cache[182] = _createElementVNode("b", null, "Pagination", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.paginationBox.style.hidden
                                                ,
                                            "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.paginationBox.style.hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.paginationBox.alwaysShow
                                                ,
                                            "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.paginationBox.alwaysShow
                                                ) = $event)),
                                            color: "primary",
                                            label: "Toujours afficher la pagination",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.paginationBox.style.hidden
                                                
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mb-2 align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[183] || (_cache[183] = _createElementVNode("span", { class: "mr-2" }, "Position", -1)),
                                          _createVNode(_component_v_btn_toggle, {
                                            mandatory: "force",
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.paginationBox.position
                                                ,
                                            "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.paginationBox.position
                                                ) = $event)),
                                            divided: "",
                                            variant: "outlined",
                                            density: "comfortable"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-left",
                                                value: "left",
                                                size: "small",
                                                variant: "outlined"
                                              }),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-center",
                                                value: "center",
                                                size: "small",
                                                variant: "outlined"
                                              }),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-align-right",
                                                value: "right",
                                                size: "small",
                                                variant: "outlined"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.paginationBox.style,
                                        "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.invoiceThemeSettings.paginationBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "pagination-block",
                                        title: "Options avancéees d'édition",
                                        divider: false,
                                        onEditing: _ctx.editing,
                                        unusedOptions: ['hidden'],
                                        disabled: _ctx.invoiceThemeSettings.paginationBox.style.hidden
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[125] || (_cache[125] = ($event: any) => (_ctx.editing('invoiceFooterTextInner-block'))),
                            "data-cy": "InvoiceThemeMenu-piedDePage"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[184] || (_cache[184] = _createElementVNode("b", null, "Pied de page", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.footerContentBox.style
                                                        .hidden
                                                ,
                                            "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.footerContentBox.style
                                                        .hidden
                                                ) = $event)),
                                            color: "primary",
                                            label: "Cacher le bloc",
                                            density: "compact",
                                            "hide-details": "auto",
                                            "data-cy": "InvoiceThemeMenu-piedDePageCacherBloc"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.style.displayFooterDivider
                                                ,
                                            "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.style.displayFooterDivider
                                                ) = $event)),
                                            label: "Afficher le trait de séparation",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            disabled: 
                                                    _ctx.invoiceThemeSettings.footerContentBox.style
                                                        .hidden
                                                ,
                                            "data-cy": "InvoiceThemeMenu-afficherLeTraitDeSeparation"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThemeSettings.useAdvancedStyling)
                                    ? (_openBlock(), _createBlock(_component_AdvancedBoxEditor, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThemeSettings.footerContentBox.style,
                                        "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.invoiceThemeSettings.footerContentBox.style) = $event)),
                                        perRow: 2,
                                        editedElementClass: "invoiceFooterTextInner-block",
                                        onEditing: _ctx.editing,
                                        unusedOptions: ['hidden'],
                                        disabled: 
                                            _ctx.invoiceThemeSettings.footerContentBox.style.hidden
                                        
                                      }, null, 8, ["modelValue", "onEditing", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[140] || (_cache[140] = ($event: any) => (_ctx.editing(null))),
                            "data-cy": "InvoiceThemeMenu-pagesSuivantes"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[185] || (_cache[185] = _createElementVNode("b", null, "Pages suivantes", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => _cache[186] || (_cache[186] = [
                                          _createElementVNode("span", null, "Les éléments sélectionnés seront répétés sur les nouvelles pages.", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .header
                                                ,
                                            "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .header
                                                ) = $event)),
                                            color: "primary",
                                            label: "Entête",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[127] || (_cache[127] = ($event: any) => (_ctx.editing('invoiceHeader-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .footer
                                                ,
                                            "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .footer
                                                ) = $event)),
                                            color: "primary",
                                            label: "Pied de page",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[129] || (_cache[129] = ($event: any) => (_ctx.editing('invoiceFooterTextInner-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .emitter
                                                ,
                                            "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .emitter
                                                ) = $event)),
                                            color: "primary",
                                            label: "Emetteur",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx.editing('emitter-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .receiver
                                                ,
                                            "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .receiver
                                                ) = $event)),
                                            color: "primary",
                                            label: "Destinataire",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[133] || (_cache[133] = ($event: any) => (_ctx.editing('receiver-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .titleBox
                                                ,
                                            "onUpdate:modelValue": [
                                              _cache[134] || (_cache[134] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .titleBox
                                                ) = $event)),
                                              _cache[135] || (_cache[135] = ($event: any) => (
                                                    _ctx.handleTitleCheckBoxChange($event)
                                                ))
                                            ],
                                            color: "primary",
                                            label: "Infos de la facture",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[136] || (_cache[136] = ($event: any) => (_ctx.editing('invoiceTitle-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .invoiceNumberBox
                                                ,
                                            "onUpdate:modelValue": [
                                              _cache[137] || (_cache[137] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .invoiceNumberBox
                                                ) = $event)),
                                              _cache[138] || (_cache[138] = ($event: any) => (
                                                    _ctx.handleInvoiceNumberCheckBoxChange($event)
                                                ))
                                            ],
                                            color: "primary",
                                            label: "Numéro de la facture",
                                            density: "compact",
                                            "hide-details": "auto",
                                            onClick: _cache[139] || (_cache[139] = ($event: any) => (_ctx.editing('invoiceTitle-block')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel, {
                            onClick: _cache[145] || (_cache[145] = ($event: any) => (_ctx.editing(null))),
                            "data-cy": "InvoiceThemeMenu-annexe"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "align-center my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[187] || (_cache[187] = _createElementVNode("b", null, "Annexe", -1)),
                                      _createVNode(_component_v_col, { class: "d-flex align-center px-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_checkbox, {
                                            modelValue: 
                                                    _ctx.invoiceThemeSettings.appendix.includeAppendix
                                                ,
                                            "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((
                                                    _ctx.invoiceThemeSettings.appendix.includeAppendix
                                                ) = $event)),
                                            label: "Joindre une annexe",
                                            color: "primary",
                                            density: "compact",
                                            "hide-details": "auto",
                                            "data-cy": "InvoiceThemeMenu-joindreUneAnnexe"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "d-flex flex-column pl-2 mt-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_15, [
                                            _createVNode(_component_v_btn, {
                                              variant: "outlined",
                                              rounded: "lg",
                                              onClick: _ctx.openInvoiceAppendixUploadDialog,
                                              disabled: 
                                                        !_ctx.invoiceThemeSettings.appendix
                                                            .includeAppendix
                                                    ,
                                              "data-cy": "InvoiceThemeMenu-changer"
                                            }, {
                                              default: _withCtx(() => [
                                                _cache[188] || (_cache[188] = _createElementVNode("span", { class: "mx-2" }, "Changer", -1)),
                                                _createVNode(_component_v_icon, {
                                                  size: "small",
                                                  icon: "$oss-upload"
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick", "disabled"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.invoiceAppendixUploadDialog)
                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                    key: 0,
                                    modelValue: _ctx.invoiceAppendixUploadDialog,
                                    "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.invoiceAppendixUploadDialog) = $event)),
                                    title: "Importer une annexe",
                                    actions: _ctx.appendixActions,
                                    "max-width": "900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UploadDocuments, {
                                        key: "appendix",
                                        companyId: _ctx.companyId,
                                        documentType: 'BOOKLET_TEMPLATE',
                                        multiple: false,
                                        freeTag: false,
                                        actions: _ctx.appendixActions,
                                        showActionsBtn: false,
                                        inExtensions: ['pdf'],
                                        onFile: _cache[142] || (_cache[142] = ($event: any) => (_ctx.updateInvoiceAppendix($event))),
                                        onFileUploaded: _cache[143] || (_cache[143] = ($event: any) => (_ctx.invoiceAppendixUploadDialog = false))
                                      }, null, 8, ["companyId", "actions"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "actions"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            key: "showInformationsTab",
            value: "showInformationsTab",
            class: "fill-height ml-2 mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CompanyLogo, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LegalForm, {
                        companyId: _ctx.companyId,
                        onChangedInfo: _ctx.onLegalFormInfoChanged
                      }, null, 8, ["companyId", "onChangedInfo"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            key: "showAdvanceSettingsTab",
            value: "showAdvanceSettingsTab",
            class: "fill-height ml-2 mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InvoiceAdvanceSetting, { companyId: _ctx.companyId }, null, 8, ["companyId"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}